import ArrowBackIcon from "@bmi-digital/components/icon/ArrowBack";
import { microCopy } from "@bmi-digital/dxb-microcopies";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "gatsby";
import React, { type FC, type ReactElement } from "react";
import { getBackToResultsPath } from "../utils/filters";
import useBackNavigation from "../hooks/useBackNavigation";
import { useSiteContext } from "./Site";
import {
  BackToResultsElement,
  BackToResultsSeparator,
  StyledButton
} from "./styles/BackToResultsStyles";

interface Props {
  children: ReactElement;
  isDarkThemed?: boolean;
  "data-testid"?: string;
}

const BackToResults: FC<Props> = ({
  children,
  isDarkThemed = false,
  "data-testid": dataTestId
}: Props) => {
  const { countryCode, getMicroCopy } = useSiteContext();
  const backNavigation = useBackNavigation();

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  if (backNavigation) {
    return (
      <BackToResultsElement
        data-testid={dataTestId || `back-to-results-section`}
      >
        <StyledButton
          startIcon={<ArrowBackIcon />}
          variant="text"
          hasDarkBackground={isDarkThemed}
          to={getBackToResultsPath(backNavigation, countryCode)}
          component={Link}
          gtm={{
            id: `nav-breadcrumb-back-to-results`,
            action: getBackToResultsPath(backNavigation, countryCode),
            label: getMicroCopy(microCopy.SEARCH_BACK_TO_RESULTS)
          }}
          data-testid={`back-to-results-button`}
        >
          {getMicroCopy(microCopy.SEARCH_BACK_TO_RESULTS)}
        </StyledButton>
        {isDesktop && (
          <>
            <BackToResultsSeparator data-testid={`back-to-results-separator`} />
            {children}
          </>
        )}
      </BackToResultsElement>
    );
  }

  return <>{children}</>;
};

export default BackToResults;
